import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";

import { useSelector } from "react-redux";
import { mergeManagedContent } from "../../hooks/mergeManagedContent";
import { colors } from "../../theme/designTokens";

export default function HowToOrder({ dark }) {
  const [contentSettings, setContentSettings] = useState([]);
  const [langId, setLangId] = useState("");

  // Store
  const { managedContentSettings } = useSelector(
    (state) => state.managedContentSettings
  );
  const { activeLangFront } = useSelector((state) => state.miscFront);
  const { langs } = useSelector((state) => state.misc);

  // Set Language
  useEffect(() => {
    if (activeLangFront) setLangId(activeLangFront._id);
  }, [activeLangFront]);

  // Set Settings
  useEffect(() => {
    if (
      managedContentSettings &&
      managedContentSettings.length > 0 &&
      langId !== ""
    ) {
      const M = mergeManagedContent(managedContentSettings, langId, langs);
      if (M) setContentSettings(M);
    }
  }, [langId, managedContentSettings]);

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
        columnGap: 5,
        rowGap: 1.75,
      }}
    >
      {contentSettings.howToOrderSteps &&
        contentSettings.howToOrderSteps.length > 0 &&
        contentSettings.howToOrderSteps.map((x, i) => (
          <Box key={i} sx={{ display: "flex", alignItems: "flex-start", gap: 1.5 }}>
            <Box
              sx={{
                flexShrink: 0,
                width: 26,
                height: 26,
                borderRadius: "999px",
                bgcolor: "#E8622E",
                color: "#fff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: 13,
                fontWeight: 700,
              }}
            >
              {i + 1}
            </Box>
            <Typography
              sx={{
                fontSize: 14,
                color: dark ? colors.white : colors.ink2,
                opacity: dark ? 0.92 : 1,
                lineHeight: 1.5,
                pt: 0.25,
              }}
            >
              {x}
            </Typography>
          </Box>
        ))}
    </Box>
  );
}
